import { Group, rem, Text } from '@mantine/core';
import { Dropzone, DropzoneProps, IMAGE_MIME_TYPE, PDF_MIME_TYPE } from '@mantine/dropzone';
import { IconPhoto, IconUpload, IconX } from '@tabler/icons-react';

export function FileDropzone(props: Partial<DropzoneProps>) {
    return (
        <Dropzone
            onDrop={(files) => props.onDrop && props.onDrop(files)}
            onReject={(files) => props.onReject && props.onReject(files)}
            maxSize={10 * 1024 ** 2}
            accept={[...IMAGE_MIME_TYPE, ...PDF_MIME_TYPE]}
            {...props}
        >
            <Group justify="center" gap="xl" style={{ pointerEvents: 'none' }}>
                <Dropzone.Accept>
                    <IconUpload style={{ width: rem(52), height: rem(52), color: 'var(--mantine-color-blue-6)' }} stroke={1.5} />
                </Dropzone.Accept>
                <Dropzone.Reject>
                    <IconX style={{ width: rem(52), height: rem(52), color: 'var(--mantine-color-red-6)' }} stroke={1.5} />
                </Dropzone.Reject>
                <Dropzone.Idle>
                    <IconPhoto style={{ width: rem(52), height: rem(52), color: 'var(--mantine-color-dimmed)' }} stroke={1.5} />
                </Dropzone.Idle>

                <div>
                    <Text size="xl" inline>
                        Drag files here or click to select files
                    </Text>
                    <Text size="sm" c="dimmed" inline mt={7}>
                        Attach as many files as you like, each file should not exceed 10mb
                    </Text>
                </div>
            </Group>
        </Dropzone>
    );
}
